import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useMutation, useQuery } from 'react-query';
import api from '../../services/api';

/**
 * ?꾨??ъ뾽?먯슜 鍮뚮쭅 愿由?而댄룷?뚰듃
 * 湲곗〈 濡쒖쭅 ?좎?
 */
const PropertyOwnerBilling = () => {
  const [activeTab, setActiveTab] = useState('billing-work');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createForm, setCreateForm] = useState({
    billing_month: '',
    work_week_start: ''
  });
  
  // ?쇨큵 泥섎━ 愿???곹깭
  const [selectedStatements, setSelectedStatements] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  
  // ?곸꽭蹂닿린 紐⑤떖 愿???곹깭
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedStatement, setSelectedStatement] = useState(null);
  
  // ?꾨떖 紐⑤떖 愿???곹깭
  const [showDeliverModal, setShowDeliverModal] = useState(false);
  const [deliverStatement, setDeliverStatement] = useState(null);
  const [deliverForm, setDeliverForm] = useState({
    method: 'email',
    template_id: '',
    custom_message: '泥?뎄?쒕? ?덈궡?쒕┰?덈떎.'
  });
  
  // ?쇨큵 ?꾨떖 紐⑤떖 愿???곹깭
  const [showBatchDeliverModal, setShowBatchDeliverModal] = useState(false);
  const [batchDeliverForm, setBatchDeliverForm] = useState({
    method: 'email',
    template_id: '',
    custom_message: '泥?뎄?쒕? ?덈궡?쒕┰?덈떎.'
  });

  // 鍮뚮쭅 ?몄뀡 議고쉶
  const { data: sessionsData, refetch: refetchSessions } = useQuery(
    ['billing-sessions', selectedMonth, selectedBuilding],
    () => api.get('/billing-work/sessions', {
      params: {
        billing_month: selectedMonth || undefined,
        building_id: selectedBuilding || undefined
      }
    }),
    {
      onError: (error) => {
        console.error('鍮뚮쭅 ?몄뀡 議고쉶 ?ㅻ쪟:', error);
        toast.error('鍮뚮쭅 ?몄뀡??遺덈윭?ㅻ뒗???ㅽ뙣?덉뒿?덈떎.');
      }
    }
  );

  // 鍮뚮쭅 ?댁뿭 議고쉶
  const { data: historyData, refetch: refetchHistory } = useQuery(
    ['billing-history', selectedMonth, selectedBuilding],
    () => api.get('/billing-work/history', {
      params: {
        billing_month: selectedMonth || undefined,
        building_id: selectedBuilding || undefined
      }
    }),
    {
      onError: (error) => {
        console.error('鍮뚮쭅 ?댁뿭 議고쉶 ?ㅻ쪟:', error);
        toast.error('鍮뚮쭅 ?댁뿭??遺덈윭?ㅻ뒗???ㅽ뙣?덉뒿?덈떎.');
      }
    }
  );

  // 泥?뎄???곸꽭 議고쉶
  const { data: detailData, refetch: refetchDetail } = useQuery(
    ['billing-detail', selectedStatement],
    () => api.get(`/billing-work/statement/${selectedStatement}`),
    {
      enabled: !!selectedStatement,
      onError: (error) => {
        console.error('泥?뎄???곸꽭 議고쉶 ?ㅻ쪟:', error);
        toast.error('泥?뎄???곸꽭 ?뺣낫瑜?遺덈윭?ㅻ뒗???ㅽ뙣?덉뒿?덈떎.');
      }
    }
  );

  // 硫붿떆吏 ?쒗뵆由?議고쉶
  const { data: templatesData } = useQuery(
    'message-templates',
    () => api.get('/message-templates'),
    {
      onError: (error) => {
        console.error('硫붿떆吏 ?쒗뵆由?議고쉶 ?ㅻ쪟:', error);
      }
    }
  );

  // 鍮뚮쭅 ?ㅽ뻾 裕ㅽ뀒?댁뀡
  const executeBillingMutation = useMutation(
    (data) => api.post('/billing-work/start-billing', data),
    {
      onSuccess: (response) => {
        toast.success('鍮뚮쭅???깃났?곸쑝濡??ㅽ뻾?섏뿀?듬땲??');
        setShowCreateModal(false);
        setCreateForm({ billing_month: '', work_week_start: '' });
        refetchSessions();
      },
      onError: (error) => {
        console.error('鍮뚮쭅 ?ㅽ뻾 ?ㅻ쪟:', error);
        toast.error(error.response?.data?.error || '鍮뚮쭅 ?ㅽ뻾???ㅽ뙣?덉뒿?덈떎.');
      }
    }
  );

  // ?쇨큵 ?뺤젙 裕ㅽ뀒?댁뀡
  const batchConfirmMutation = useMutation(
    (data) => api.post('/billing/statements/batch-confirm', data),
    {
      onSuccess: (response) => {
        toast.success(response.data.message || '泥?뎄?쒓? ?쇨큵 ?뺤젙?섏뿀?듬땲??');
        setSelectedStatements([]);
        setSelectAll(false);
        refetchHistory();
      },
      onError: (error) => {
        console.error('?쇨큵 ?뺤젙 ?ㅻ쪟:', error);
        toast.error(error.response?.data?.error || '?쇨큵 ?뺤젙???ㅽ뙣?덉뒿?덈떎.');
      }
    }
  );

  // ?쇨큵 ?꾨떖 裕ㅽ뀒?댁뀡
  const batchDeliverMutation = useMutation(
    (data) => api.post('/billing-work/statements/batch-deliver', data),
    {
      onSuccess: (response) => {
        toast.success(response.data.message || '泥?뎄?쒓? ?쇨큵 ?꾨떖?섏뿀?듬땲??');
        setSelectedStatements([]);
        setSelectAll(false);
        setShowBatchDeliverModal(false);
        refetchHistory();
      },
      onError: (error) => {
        console.error('?쇨큵 ?꾨떖 ?ㅻ쪟:', error);
        toast.error(error.response?.data?.error || '?쇨큵 ?꾨떖???ㅽ뙣?덉뒿?덈떎.');
      }
    }
  );

  const handleCreateBilling = () => {
    if (!createForm.billing_month || !createForm.work_week_start) {
      toast.error('泥?뎄?붽낵 ?묒뾽 ?쒖옉?쇱쓣 ?낅젰?댁＜?몄슂.');
      return;
    }

    // ?묒뾽 二?怨꾩궛
    const startDate = new Date(createForm.work_week_start);
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    const billingData = {
      billing_month: createForm.billing_month,
      work_week_start: createForm.work_week_start,
      work_week_end: endDate.toISOString().split('T')[0]
    };

    executeBillingMutation.mutate(billingData);
  };

  // 泥댄겕諛뺤뒪 ?몃뱾??
  const handleSelectStatement = (statementId) => {
    setSelectedStatements(prev => 
      prev.includes(statementId) 
        ? prev.filter(id => id !== statementId)
        : [...prev, statementId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStatements([]);
    } else {
      const allStatementIds = historyData?.data?.history
        ?.filter(item => item.status === 'pending')
        ?.map(item => item.statement_id) || [];
      setSelectedStatements(allStatementIds);
    }
    setSelectAll(!selectAll);
  };

  // ?쇨큵 ?뺤젙 ?몃뱾??
  const handleBatchConfirm = () => {
    if (selectedStatements.length === 0) {
      toast.error('?뺤젙??泥?뎄?쒕? ?좏깮?댁＜?몄슂.');
      return;
    }

    batchConfirmMutation.mutate({
      statement_ids: selectedStatements
    });
  };

  // ?쇨큵 ?꾨떖 ?몃뱾??
  const handleBatchDeliver = () => {
    if (selectedStatements.length === 0) {
      toast.error('?꾨떖??泥?뎄?쒕? ?좏깮?댁＜?몄슂.');
      return;
    }

    setShowBatchDeliverModal(true);
  };

  // ?쇨큵 ?꾨떖 紐⑤떖 ?リ린
  const handleCloseBatchDeliverModal = () => {
    setShowBatchDeliverModal(false);
    setBatchDeliverForm({
      method: 'email',
      template_id: '',
      custom_message: '泥?뎄?쒕? ?덈궡?쒕┰?덈떎.'
    });
  };

  // ?쇨큵 ?꾨떖 ?ㅽ뻾
  const handleExecuteBatchDeliver = () => {
    batchDeliverMutation.mutate({
      statement_ids: selectedStatements,
      method: batchDeliverForm.method,
      template_id: batchDeliverForm.template_id || null,
      custom_message: batchDeliverForm.custom_message
    });
  };

  // ?곸꽭蹂닿린 ?몃뱾??
  const handleShowDetail = (statementId) => {
    setSelectedStatement(statementId);
    setShowDetailModal(true);
  };

  // ?곸꽭蹂닿린 紐⑤떖 ?リ린
  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedStatement(null);
  };

  // ?꾨떖 紐⑤떖 ?닿린
  const handleShowDeliver = (statementId) => {
    setDeliverStatement(statementId);
    setShowDeliverModal(true);
  };

  const handleSendRentDueKakao = async (statementId) => {
    if (!window.confirm('泥?뎄 ?⑸??덈궡 ?뚮┝?≪쓣 諛쒖넚 ?붿껌?좉퉴??')) return;
    try {
      const response = await api.post(`/message-master/rent-due/${statementId}/send`, {});
      toast.success(`?뚮┝???붿껌 ?꾨즺: ${response.status || response.data?.status || 'READY'}`);
    } catch (error) {
      toast.error(error.response?.data?.message || '?뚮┝???붿껌???ㅽ뙣?덉뒿?덈떎.');
    }
  };

  // ?꾨떖 紐⑤떖 ?リ린
  const handleCloseDeliverModal = () => {
    setShowDeliverModal(false);
    setDeliverStatement(null);
    setDeliverForm({
      method: 'email',
      custom_message: '泥?뎄?쒕? ?덈궡?쒕┰?덈떎.'
    });
  };

  // ?꾨떖 ?ㅽ뻾
  const handleDeliver = () => {
    if (!deliverStatement) return;

    const deliverData = {
      method: deliverForm.method,
      template_id: deliverForm.template_id || null,
      custom_message: deliverForm.custom_message
    };

    api.post(`/billing-work/statement/${deliverStatement}/deliver`, deliverData)
      .then(() => {
        toast.success('泥?뎄?쒓? ?꾨떖?섏뿀?듬땲??');
        handleCloseDeliverModal();
        refetchHistory();
      })
      .catch((error) => {
        toast.error('泥?뎄???꾨떖???ㅽ뙣?덉뒿?덈떎.');
        console.error(error);
      });
  };

  return (
    <div className="space-y-6">
      {/* ?ㅻ뜑 */}
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">임대료 청구관리</h1>
        <p className="text-gray-600">?꾨?猷? 愿由щ퉬, 二쇱감鍮?諛?異붽? 鍮꾩슜??泥?뎄?⑸땲??</p>
      </div>

      {/* ???ㅻ퉬寃뚯씠??*/}
      <div className="bg-white rounded-lg shadow">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8 px-6">
            <button
              onClick={() => setActiveTab('billing-work')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'billing-work'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              ?꾨?猷?泥?뎄
            </button>
            <button
              onClick={() => setActiveTab('history')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'history'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              鍮뚮쭅 ?댁뿭
            </button>
          </nav>
        </div>

        <div className="p-6">
          {activeTab === 'billing-work' && (
            <div className="space-y-6">
              {/* ?꾪꽣 */}
              <div className="flex space-x-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    泥?뎄??
                  </label>
                  <input
                    type="month"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    嫄대Ъ
                  </label>
                  <select
                    value={selectedBuilding}
                    onChange={(e) => setSelectedBuilding(e.target.value)}
                    className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">?꾩껜</option>
                    {/* 嫄대Ъ 紐⑸줉? 蹂꾨룄 API濡?議고쉶 */}
                  </select>
                </div>
              </div>

              {/* 鍮뚮쭅 ?ㅽ뻾 踰꾪듉 */}
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-medium text-gray-900">?꾨?猷?泥?뎄</h3>
                <button
                  onClick={() => setShowCreateModal(true)}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  鍮뚮쭅 ?ㅽ뻾
                </button>
              </div>

              {/* 鍮뚮쭅 ?몄뀡 紐⑸줉 */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-3">理쒓렐 鍮뚮쭅 ?몄뀡</h4>
                {sessionsData?.data?.length > 0 ? (
                  <div className="space-y-2">
                    {sessionsData.data.slice(0, 5).map((session) => (
                      <div key={session.id} className="bg-white p-3 rounded border">
                        <div className="flex justify-between items-center">
                          <div>
                            <span className="font-medium">
                              {session.billing_month} {session.session_number_in_month}李?
                            </span>
                            <span className="text-gray-500 ml-2">
                              {session.processed_contracts_count}嫄?泥섎━
                            </span>
                          </div>
                          <span className="text-sm text-gray-500">
                            {new Date(session.created_at).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500">鍮뚮쭅 ?몄뀡???놁뒿?덈떎.</p>
                )}
              </div>
            </div>
          )}

          {activeTab === 'history' && (
            <div className="space-y-6">
              {/* ?꾪꽣 */}
              <div className="flex space-x-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    泥?뎄??
                  </label>
                  <input
                    type="month"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    嫄대Ъ
                  </label>
                  <select
                    value={selectedBuilding}
                    onChange={(e) => setSelectedBuilding(e.target.value)}
                    className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">?꾩껜</option>
                    {/* 嫄대Ъ 紐⑸줉? 蹂꾨룄 API濡?議고쉶 */}
                  </select>
                </div>
              </div>

              {/* 鍮뚮쭅 ?댁뿭 ?뚯씠釉?*/}
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-medium text-gray-900">鍮뚮쭅 ?댁뿭</h3>
                  {selectedStatements.length > 0 && (
                    <div className="flex space-x-2">
                      <button
                        onClick={handleBatchConfirm}
                        disabled={batchConfirmMutation.isLoading}
                        className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 text-sm"
                      >
                        {batchConfirmMutation.isLoading ? '?뺤젙 以?..' : `?쇨큵 ?뺤젙 (${selectedStatements.length}嫄?`}
                      </button>
                      <button
                        onClick={handleBatchDeliver}
                        disabled={batchDeliverMutation.isLoading}
                        className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:opacity-50 text-sm"
                      >
                        {batchDeliverMutation.isLoading ? '?꾨떖 以?..' : `?쇨큵 ?꾨떖 (${selectedStatements.length}嫄?`}
                      </button>
                    </div>
                  )}
                </div>
                {historyData?.data?.history && historyData.data.history.length > 0 ? (
                  <div className="bg-white shadow overflow-hidden sm:rounded-md">
                    {/* ?꾩껜 ?좏깮 ?ㅻ뜑 */}
                    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label className="ml-2 text-sm font-medium text-gray-700">
                          ?꾩껜 ?좏깮 (pending ?곹깭留?
                        </label>
                      </div>
                    </div>
                    
                    {/* ?곸꽭 ?뚯씠釉?*/}
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?좏깮
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              嫄대Ъ/?몃?
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?꾩감??
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              泥?뎄??
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?붿꽭
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              愿由щ퉬
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              湲고?泥?뎄??
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              遺媛??
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?⑷퀎
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?⑹엯??
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?곹깭
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              ?≪뀡
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {historyData.data.history.map((item) => {
                            // 湲고?泥?뎄??怨꾩궛 (珥앹븸 - ?붿꽭 - 愿由щ퉬)
                            const otherCharges = item.total_amount - item.monthly_rent - item.maintenance_fee;
                            // 遺媛??怨꾩궛 (珥앹븸??10%)
                            const vat = Math.round(item.total_amount * 0.1);
                            
                            return (
                              <tr key={item.statement_id} className="hover:bg-gray-50">
                                <td className="px-4 py-4 whitespace-nowrap">
                                  {item.status === 'pending' && (
                                    <input
                                      type="checkbox"
                                      checked={selectedStatements.includes(item.statement_id)}
                                      onChange={() => handleSelectStatement(item.statement_id)}
                                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    />
                                  )}
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap">
                                  <div className="text-sm font-medium text-gray-900">
                                    {item.building_name}
                                  </div>
                                  <div className="text-sm text-gray-500">
                                    {item.unit_number}??
                                  </div>
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">
                                    {item.tenant_name}
                                  </div>
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">
                                    {item.billing_month}
                                  </div>
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                                  ??item.monthly_rent ? (item.monthly_rent / 10000).toLocaleString() : '0'}留뚯썝
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                                  ??item.maintenance_fee?.toLocaleString() || '0'}
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                                  ??otherCharges.toLocaleString()}
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                                  ??vat.toLocaleString()}
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap">
                                  <div className="text-sm font-medium text-gray-900">
                                    ₩{item.total_amount?.toLocaleString()}
                                  </div>
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {item.due_date ? item.due_date + '일' : '미설정'}
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap">
                                  <span className={'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + (
                                    item.status === 'paid' ? 'bg-green-100 text-green-800' :
                                    item.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                    item.status === 'overdue' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'
                                  )}>
                                    {item.status === 'paid' ? '납부완료' :
                                     item.status === 'pending' ? '납부대기' :
                                     item.status === 'overdue' ? '연체' : item.status}
                                  </span>
                                </td>
                                <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                                  <div className="flex space-x-2">
                                    <button
                                      onClick={() => handleShowDetail(item.statement_id)}
                                      className="text-blue-600 hover:text-blue-800"
                                    >
                                      ?곸꽭蹂닿린
                                    </button>
                                    {item.status === 'pending' && (
                                      <button
                                        onClick={() => {
                                          // 泥?뎄???뺤젙
                                          api.post(`/billing/statements/${item.statement_id}/confirm`, {})
                                            .then(() => {
                                              toast.success('泥?뎄?쒓? ?뺤젙?섏뿀?듬땲??');
                                              refetchHistory();
                                            })
                                            .catch((error) => {
                                              toast.error('泥?뎄???뺤젙???ㅽ뙣?덉뒿?덈떎.');
                                              console.error(error);
                                            });
                                        }}
                                        className="text-green-600 hover:text-green-800"
                                      >
                                        ?뺤젙
                                      </button>
                                    )}
                                    <button
                                      onClick={() => handleShowDeliver(item.statement_id)}
                                      className="text-purple-600 hover:text-purple-800"
                                    >
                                      ?꾨떖
                                    </button>
                                    <button
                                      onClick={() => handleSendRentDueKakao(item.statement_id)}
                                      className="text-indigo-600 hover:text-indigo-800"
                                    >
                                      알림톡
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <p className="text-gray-500">鍮뚮쭅 ?댁뿭???놁뒿?덈떎.</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 鍮뚮쭅 ?ㅽ뻾 紐⑤떖 */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">鍮뚮쭅 ?ㅽ뻾</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    泥?뎄??
                  </label>
                  <input
                    type="month"
                    value={createForm.billing_month}
                    onChange={(e) => setCreateForm({ ...createForm, billing_month: e.target.value })}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ?묒뾽 ?쒖옉??
                  </label>
                  <input
                    type="date"
                    value={createForm.work_week_start}
                    onChange={(e) => setCreateForm({ ...createForm, work_week_start: e.target.value })}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
                >
                  痍⑥냼
                </button>
                <button
                  onClick={handleCreateBilling}
                  disabled={executeBillingMutation.isLoading}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 disabled:opacity-50"
                >
                  {executeBillingMutation.isLoading ? '?ㅽ뻾 以?..' : '鍮뚮쭅 ?ㅽ뻾'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ?곸꽭蹂닿린 紐⑤떖 */}
      {showDetailModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-4xl shadow-lg rounded-md bg-white">
            <div className="mt-3">
              {/* 紐⑤떖 ?ㅻ뜑 */}
              <div className="flex justify-between items-center pb-4 border-b">
                <h3 className="text-lg font-medium text-gray-900">
                  泥?뎄???곸꽭 ?뺣낫
                </h3>
                <button
                  onClick={handleCloseDetailModal}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* 紐⑤떖 ?댁슜 */}
              <div className="mt-4">
                {detailData?.data ? (
                  <div className="space-y-6">
                    {/* 湲곕낯 ?뺣낫 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <h4 className="font-medium text-gray-900 mb-3">湲곕낯 ?뺣낫</h4>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">泥?뎄??ID:</span>
                            <span className="font-medium">{detailData.data.statement_id}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">泥?뎄??</span>
                            <span className="font-medium">{detailData.data.billing_month}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">?곹깭:</span>
                            <span className={'px-2 py-1 rounded-full text-xs font-medium ' + (
                              detailData.data.status === 'paid' ? 'bg-green-100 text-green-800' :
                              detailData.data.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                              detailData.data.status === 'overdue' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'
                            )}>
                              {detailData.data.status === 'paid' ? '납부완료' :
                               detailData.data.status === 'pending' ? '납부대기' :
                               detailData.data.status === 'overdue' ? '연체' : detailData.data.status}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">?앹꽦??</span>
                            <span className="font-medium">
                              {new Date(detailData.data.created_at).toLocaleDateString('ko-KR')}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="bg-gray-50 p-4 rounded-lg">
                        <h4 className="font-medium text-gray-900 mb-3">?꾩감???뺣낫</h4>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-600">?꾩감??</span>
                            <span className="font-medium">{detailData.data.tenant_name}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">嫄대Ъ:</span>
                            <span className="font-medium">{detailData.data.building_name}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">?몃?:</span>
                            <span className="font-medium">{detailData.data.unit_number}호</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">?⑹엯??</span>
                            <span className="font-medium">{detailData.data.due_date}일</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 泥?뎄 ?댁뿭 */}
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-medium text-gray-900 mb-3">泥?뎄 ?댁뿭</h4>
                      {detailData.data.line_items && detailData.data.line_items.length > 0 ? (
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">??ぉ</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">?섎웾</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">?④?</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">湲덉븸</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">鍮꾧퀬</th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                              {detailData.data.line_items.map((item, index) => (
                                <tr key={index}>
                                  <td className="px-3 py-2 text-sm text-gray-900">{item.item_name}</td>
                                  <td className="px-3 py-2 text-sm text-gray-900">{item.quantity}</td>
                                  <td className="px-3 py-2 text-sm text-gray-900">??item.unit_price?.toLocaleString()}</td>
                                  <td className="px-3 py-2 text-sm text-gray-900">??item.total_amount?.toLocaleString()}</td>
                                  <td className="px-3 py-2 text-sm text-gray-500">{item.description || '-'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p className="text-gray-500 text-sm">泥?뎄 ?댁뿭???놁뒿?덈떎.</p>
                      )}
                    </div>

                    {/* ?⑷퀎 ?뺣낫 */}
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <div className="flex justify-between items-center">
                        <span className="text-lg font-medium text-gray-900">珥?泥?뎄 湲덉븸:</span>
                        <span className="text-2xl font-bold text-blue-600">
                          ??detailData.data.total_amount?.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-2 text-gray-500">?곸꽭 ?뺣낫瑜?遺덈윭?ㅻ뒗 以?..</p>
                  </div>
                )}
              </div>

              {/* 紐⑤떖 ?명꽣 */}
              <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
                <button
                  onClick={handleCloseDetailModal}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                >
                  ?リ린
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ?꾨떖 紐⑤떖 */}
      {showDeliverModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-md shadow-lg rounded-md bg-white">
            <div className="mt-3">
              {/* 紐⑤떖 ?ㅻ뜑 */}
              <div className="flex justify-between items-center pb-4 border-b">
                <h3 className="text-lg font-medium text-gray-900">
                  泥?뎄???꾨떖
                </h3>
                <button
                  onClick={handleCloseDeliverModal}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* 紐⑤떖 ?댁슜 */}
              <div className="mt-4 space-y-4">
                {/* ?꾨떖 諛⑸쾿 ?좏깮 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?꾨떖 諛⑸쾿
                  </label>
                  <div className="space-y-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="email"
                        checked={deliverForm.method === 'email'}
                        onChange={(e) => setDeliverForm({...deliverForm, method: e.target.value})}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <span className="ml-2 text-sm text-gray-700">이메일</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="sms"
                        checked={deliverForm.method === 'sms'}
                        onChange={(e) => setDeliverForm({...deliverForm, method: e.target.value})}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <span className="ml-2 text-sm text-gray-700">SMS</span>
                    </label>
                  </div>
                </div>

                {/* ?쒗뵆由??좏깮 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    硫붿떆吏 ?쒗뵆由?
                  </label>
                  <select
                    value={deliverForm.template_id}
                    onChange={(e) => {
                      const templateId = e.target.value;
                      const selectedTemplate = templatesData?.data?.templates?.find(t => t.id === parseInt(templateId));
                      setDeliverForm({
                        ...deliverForm,
                        template_id: templateId,
                        custom_message: selectedTemplate ? selectedTemplate.content : deliverForm.custom_message
                      });
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">?쒗뵆由??좏깮 (?좏깮?ы빆)</option>
                    {templatesData?.data?.templates?.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* 硫붿떆吏 ?낅젰 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    硫붿떆吏
                  </label>
                  <textarea
                    value={deliverForm.custom_message}
                    onChange={(e) => setDeliverForm({...deliverForm, custom_message: e.target.value})}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="전달할 메시지를 입력하세요"
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    蹂???ъ슜 媛?? {`{tenant_name}`, `{building_name}`, `{unit_number}`, `{billing_month}`, `{total_amount}`, `{due_date}`}
                  </p>
                </div>

                {/* 誘몃━蹂닿린 */}
                <div className="bg-gray-50 p-3 rounded-md">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">硫붿떆吏 誘몃━蹂닿린:</h4>
                  <div className="text-sm text-gray-600 whitespace-pre-wrap">
                    {deliverForm.custom_message
                      .replace('{tenant_name}', '源泥좎닔')
                      .replace('{building_name}', '?뚯뒪??鍮뚮씪')
                      .replace('{unit_number}', '0101')
                      .replace('{billing_month}', '2025-11')
                      .replace('{total_amount}', '550,000원')
                      .replace('{due_date}', '1일')
                    }
                  </div>
                </div>
              </div>

              {/* 紐⑤떖 ?명꽣 */}
              <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
                <button
                  onClick={handleCloseDeliverModal}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                >
                  痍⑥냼
                </button>
                <button
                  onClick={handleDeliver}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
                >
                  ?꾨떖
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ?쇨큵 ?꾨떖 紐⑤떖 */}
      {showBatchDeliverModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-md shadow-lg rounded-md bg-white">
            <div className="mt-3">
              {/* 紐⑤떖 ?ㅻ뜑 */}
              <div className="flex justify-between items-center pb-4 border-b">
                <h3 className="text-lg font-medium text-gray-900">
                  泥?뎄???쇨큵 ?꾨떖 ({selectedStatements.length}嫄?
                </h3>
                <button
                  onClick={handleCloseBatchDeliverModal}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* 紐⑤떖 ?댁슜 */}
              <div className="mt-4 space-y-4">
                {/* ?꾨떖 諛⑸쾿 ?좏깮 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ?꾨떖 諛⑸쾿
                  </label>
                  <div className="space-y-2">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="email"
                        checked={batchDeliverForm.method === 'email'}
                        onChange={(e) => setBatchDeliverForm({...batchDeliverForm, method: e.target.value})}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <span className="ml-2 text-sm text-gray-700">이메일</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="sms"
                        checked={batchDeliverForm.method === 'sms'}
                        onChange={(e) => setBatchDeliverForm({...batchDeliverForm, method: e.target.value})}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <span className="ml-2 text-sm text-gray-700">SMS</span>
                    </label>
                  </div>
                </div>

                {/* ?쒗뵆由??좏깮 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    硫붿떆吏 ?쒗뵆由?
                  </label>
                  <select
                    value={batchDeliverForm.template_id}
                    onChange={(e) => {
                      const templateId = e.target.value;
                      const selectedTemplate = templatesData?.data?.templates?.find(t => t.id === parseInt(templateId));
                      setBatchDeliverForm({
                        ...batchDeliverForm,
                        template_id: templateId,
                        custom_message: selectedTemplate ? selectedTemplate.content : batchDeliverForm.custom_message
                      });
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">?쒗뵆由??좏깮 (?좏깮?ы빆)</option>
                    {templatesData?.data?.templates?.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* 硫붿떆吏 ?낅젰 */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    硫붿떆吏
                  </label>
                  <textarea
                    value={batchDeliverForm.custom_message}
                    onChange={(e) => setBatchDeliverForm({...batchDeliverForm, custom_message: e.target.value})}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="전달할 메시지를 입력하세요"
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    蹂???ъ슜 媛?? {`{tenant_name}`, `{building_name}`, `{unit_number}`, `{billing_month}`, `{total_amount}`, `{due_date}`}
                  </p>
                </div>

                {/* 誘몃━蹂닿린 */}
                <div className="bg-gray-50 p-3 rounded-md">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">硫붿떆吏 誘몃━蹂닿린:</h4>
                  <div className="text-sm text-gray-600 whitespace-pre-wrap">
                    {batchDeliverForm.custom_message
                      .replace('{tenant_name}', '源泥좎닔')
                      .replace('{building_name}', '?뚯뒪??鍮뚮씪')
                      .replace('{unit_number}', '0101')
                      .replace('{billing_month}', '2025-11')
                      .replace('{total_amount}', '550,000원')
                      .replace('{due_date}', '1일')
                    }
                  </div>
                </div>
              </div>

              {/* 紐⑤떖 ?명꽣 */}
              <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
                <button
                  onClick={handleCloseBatchDeliverModal}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                >
                  痍⑥냼
                </button>
                <button
                  onClick={handleExecuteBatchDeliver}
                  disabled={batchDeliverMutation.isLoading}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:opacity-50"
                >
                  {batchDeliverMutation.isLoading ? '?꾨떖 以?..' : `${selectedStatements.length}嫄??꾨떖`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyOwnerBilling;
